import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/projects.css';
import '../styles/sections.css';
import { HiStar } from 'react-icons/hi';

const projects = [
    {
      title: 'DevHive',
      description: 'A full-stack project collaboration platform engineered for agile teams. Features include real-time messaging via Firebase, dynamic Kanban boards, sprint-based task tracking, and role-based user invites. Built with Flutter (mobile), ReactJS (web), and ASP.NET (backend), integrated with MySQL, and deployed on AWS for scalable performance.',
      link: 'https://kaihedrick.com/devhive-showcase#intro',
      isExternal: true
    },
    {
      title: 'Swipe',
      description: 'A social media iOS application built with React Native and Expo, tested via Apple TestFlight. Features a Go backend deployed on AWS Lambda and API Gateway, with PostgreSQL database hosted on Neon. Includes AWS Rekognition for automated image content moderation and IPFS Pinata for decentralized image storage. The app provides users with a modern social media experience for connecting, sharing content, and interacting with other users.',
      link: '/swipe',
      isExternal: false
    },
    {
      title: 'CLIMB OR DIE!',
      description: 'A thrilling Roblox game where players must climb to survive! Navigate challenging obstacles, avoid deadly traps, and race against time to reach the top. Features include dynamic difficulty scaling, power-ups, leaderboards, and multiple game modes. Built with Roblox Studio using Lua scripting, showcasing game development skills and creative gameplay mechanics.',
      link: '/climbor-die',
      isExternal: false
    },
    {
      title: 'Notify',
      description: 'Notify is a music streaming platform built with ASP.NET and hosted on Azure, featuring YouTube integration, user authentication, playlist creation, music liking, account management, and a built-in merchandise store. Users can stream music, curate playlists, favorite songs, send feedback, and browse branded products—all within a seamless web experience.',
      link: '/notify',
      isExternal: false
    }
  ];

const Projects = () => (
  <div className="projects-section">
    <div className="section-header">
        <h2>PROJECTS</h2>
        <div className="underline"></div>
    </div>
    <br></br>
    <div className="projects-grid">
      {projects.map((project, index) => (
        project.isExternal ? (
          // External link (DevHive) - opens in new tab
          <a href={project.link} key={index} className="project-card" target="_blank" rel="noopener noreferrer">
            <h3>
              {project.title}
              {project.title === 'DevHive' && (
                <HiStar style={{ color: 'white', marginLeft: '8px', verticalAlign: 'middle' }} />
              )}
            </h3>
            <p>{project.description}</p>
          </a>
        ) : (
          // Internal link (Notify, CLIMB OR DIE!) - navigates in same tab
          <Link to={project.link} key={index} className="project-card">
            <h3>
              {project.title}
              {project.title === 'DevHive' && (
                <HiStar style={{ color: 'white', marginLeft: '8px', verticalAlign: 'middle' }} />
              )}
            </h3>
            <p>{project.description}</p>
          </Link>
        )
      ))}
    </div>
  </div>
);

export default Projects;